module.exports = __webpack_public_path__ + "media/images/favicons/android-icon-192x192-7f601e9ab2a06bbd5f1e3ea07414413b.png";